var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "apartment-document" },
    [
      _c("v-card-title", { attrs: { "primary-title": "" } }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "h4",
            {
              staticClass:
                "headline mb-0 primary--text apartment-document--border-bottom-2"
            },
            [_vm._v(_vm._s(_vm.$t(_vm.lblSetting.blockDocumentTitle)))]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs6: "", md6: "" } },
        _vm._l(_vm.dtDocuments, function(document, index) {
          return _c(
            "v-layout",
            {
              key: index,
              staticClass: "document-content py-1  ml-3",
              attrs: { row: "", wrap: "" }
            },
            [
              _c(
                "div",
                { staticClass: "px-3 py-2" },
                [
                  _c("v-icon", { attrs: { color: "primary" } }, [
                    _vm._v(_vm._s(document.icon))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("v-layout", { attrs: { column: "", wrap: "" } }, [
                _c(
                  "label",
                  {
                    staticClass: "document-content__title",
                    attrs: { for: "" }
                  },
                  [_vm._v(_vm._s(document.title))]
                ),
                _vm._v(" "),
                _c("span", [
                  _vm._v("Mis en ligne le " + _vm._s(document.createdAt))
                ])
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "document-content__type" }, [
                _vm._v(" " + _vm._s(document.type.translationKey))
              ])
            ],
            1
          )
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-md-center" },
        [
          _c("base-modal-submit-btn", {
            attrs: { title: "Modifier les informations" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29fef2da", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29fef2da","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/block/components/block-apartment-documents/template.html
// module id = null
// module chunks = 